import { jsx as _jsx } from "react/jsx-runtime";
import { PageLoading } from 'components/atoms/loading';
import { ErrorBoundary } from 'components/molecules/error-boundary';
import { CallbackErrorPage } from './error';
import { LoginCallback } from './login-callback';
export const ImplicitCallback = ()=>{
    return /*#__PURE__*/ _jsx(ErrorBoundary, {
        children: /*#__PURE__*/ _jsx(LoginCallback, {
            loadingElement: /*#__PURE__*/ _jsx(PageLoading, {}),
            errorComponent: CallbackErrorPage
        })
    });
};
